import React from "react";

const Transactions = () => {
  const transactions = [
    { name: "Mobile Money", rate: "1%" },
    { name: "Payouts", rate: "1%" },
    { name: "Credit Cards", rate: "3.5%" },
    { name: "Crypto", rate: "3.5%" },
  ];

  return (
    <section className="px-6 xl:px-0 text-blackColor">
      <div className="mx-auto max-w-6xl h-full">
        <div className="space-y-3">
          <h2 className="hidden text-center text-2xl font-semibold md:leading-[3.4rem] md:text-4xl lg:block">
            Simple Pricing. <br />
            No Monthly Fees.
          </h2>

          <h2 className="text-center text-2xl font-semibold md:leading-[3.4rem] md:text-4xl lg:hidden">
            Simple Pricing. No Monthly Fees.
          </h2>

          <p className="text-center mx-auto md:w-1/2">
            We only make money, when you make more.
          </p>
        </div>
        <div className=" bg-white rounded-[20px] gap-y-10 shadow-[0px 4px 4px rgba(0, 0, 0, 0.1)] py-8 grid grid-cols-2 mt-8 md:space-y-0 md:gap-5 md:px-8 md:py-16 md:rounded-[40px] lg:grid-cols-4 lg:gap-0">
          {transactions.map((transaction, i) => (
            <div key={i} className="text-center space-y-1 md:space-y-4">
              <h3 className="text-lg font-semibold md:text-xl">
                {transaction.name}
              </h3>
              <h3 className="text-3xl text-brandColor font-semibold md:text-5xl">
                {transaction.rate}
              </h3>
              <p className="text-gray-600 text-[14px]">Per Transaction</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Transactions;
